import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=81d5dce0&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports